module.exports = __webpack_public_path__ + "img/card-contract.fd162937.svg";